export const LIST_FORM_CONFIG = 'LIST_FORM_CONFIG';
export const DELETE_FORM_CONFIG = 'DELETE_FORM_CONFIG';
export const DELETES_FORM_CONFIG = 'DELETES_FORM_CONFIG';
export const SHOW_FORM_CONFIG = 'SHOW_FORM_CONFIG';
export const SHOW_ACCOUNT_CONFIG = 'SHOW_ACCOUNT_CONFIG';
export const ADD_ACCOUNT_CONFIG = 'ADD_ACCOUNT_CONFIG';
export const CANCEL_ACCOUNT_CONFIG = 'CANCEL_ACCOUNT_CONFIG';
export const RELOAD_FORM_CONFIG = 'RELOAD_FORM_CONFIG';
export const CREATE_FORM_CONFIG = 'CREATE_FORM_CONFIG';
export const UPDATE_FORM_CONFIG = 'UPDATE_FORM_CONFIG';